import { createSelector } from '@reduxjs/toolkit';

import { type RootState } from '@/stores/store';

export const selectSyncFeature = (s: RootState) => s.editor.sync;

const selectPendingSync = createSelector([selectSyncFeature], (s) => s.pending);
const selectSyncingFiles = createSelector(
  [selectSyncFeature],
  (s) => s.syncing,
);
export const selectSyncingFilesAsArray = createSelector(
  [selectSyncingFiles],
  (s) => Object.values(s),
);
export const selectPendingSyncAsArray = createSelector(
  [selectPendingSync],
  (p) => Object.values(p),
);
export const selectHasPendingFiles = createSelector(
  [selectPendingSyncAsArray],
  (p) => Boolean(p.length),
);
export const selectSyncLoading = createSelector(
  [selectSyncingFilesAsArray],
  (s) => s.length > 0,
);
